import SearchPreviews from './SearchPreviews';

export default SearchPreviews;
